import request from '@/utils/request'
import qs from 'qs'
/**
 * 获取token
 */
export function getTokenCode(data) {
    return request({
        url: '/getTokenCode',
        method: 'get',
    })
}
/**
 * 获取authcode
 */
export function getAuthCode(params) {
    return request({
        url: '/getAuthCode',
        method: 'get',
        params
    })
}


/**
 * 获取用户信息
 */
export function getUserInfo(authCode) {
    return request({
        url: `/getUserInfo/${authCode}`,
        method: 'get',
    })
}

// 测试时使用登录接口
export function getloginDemoApi(account) {
    return request({
        url: `/auth/pwd/login/demo/${account}/zf/7Z8t9x0y1u2i3o4p5a6s7d8f9g0h1j2k3l4m=`,
        method: 'post',
    })
}

export function getUserInfoApi(id) {
  return request({
    url: `/zf/sys/user/${id}`,
    method: "get",
  });
}

// 统计活跃度
export function getHydApi() {
  return request({
    url: `/auth/admin/login/hyd/zfh5`,
    method: 'get',
  })
}